module.exports = __webpack_public_path__ + "img/Mom-icons_SEO.2bc2fcef.png";